import { CustomerDto, defaultCustomerDto } from 'src/dtos/customer/customerDto';
import { defaultItem, ItemDto } from 'src/dtos/item/itemDto';

export const SAL2050_R01_SUBTOTAL_TYPES = {
	CUSTOMER: 'customer',
	ITEM: 'item',
} as const;

// 소계 행의 그룹 기준(거래처별/품목별)
export type SubtotalType = typeof SAL2050_R01_SUBTOTAL_TYPES[keyof typeof SAL2050_R01_SUBTOTAL_TYPES];

// 전년·당년 매출액과 증감액/증감율
export interface SalesPerformanceAmount {
	prevYearSalesAmt: number;
	currYearSalesAmt: number;
	diffAmt: number;
	diffRate: number;
}

// 거래처별 탭 전년대비실적
export interface CustomerSalesPerformanceDto extends CustomerDto, SalesPerformanceAmount {
	compCd: string;
	compNm: string;
}

// 품목별 탭 전년대비실적
export interface ItemSalesPerformanceDto extends ItemDto, SalesPerformanceAmount {
	compCd: string;
	compNm: string;
}

// 그리드에 끼워 넣는 소계 행
export interface SAL2050_R01SubtotalRow extends SalesPerformanceAmount {
	isSubtotal: true;
	subtotalType: SubtotalType;
	groupKey: string;
	groupLabel: string;
	count: number;
	compCd: string;
	compNm: string;
	customCd: string;
	customNm: string;
	itemCd: string;
	itemNm: string;
	itemSpec: string;
	remark: string;
	valueIndex: number;
	orderIndex: number;
	orderIndexSeq: number;
	inserted: boolean;
	isModified: boolean;
}

// 탭별 실적 DTO 통합 타입
export type SAL2050_R01Dto = CustomerSalesPerformanceDto | ItemSalesPerformanceDto;

// 상세 행과 소계 행을 함께 담는 그리드 행
export type GridRowData = SAL2050_R01Dto | SAL2050_R01SubtotalRow;

export const defaultCustomerSalesPerformanceDto: CustomerSalesPerformanceDto = {
	...defaultCustomerDto,
	compCd: '',
	compNm: '',
	prevYearSalesAmt: 0,
	currYearSalesAmt: 0,
	diffAmt: 0,
	diffRate: 0,
};

export const defaultItemSalesPerformanceDto: ItemSalesPerformanceDto = {
	...defaultItem,
	compCd: '',
	compNm: '',
	prevYearSalesAmt: 0,
	currYearSalesAmt: 0,
	diffAmt: 0,
	diffRate: 0,
};

export const defaultGridRowData: GridRowData = {
	...defaultCustomerSalesPerformanceDto,
	isSubtotal: true,
	subtotalType: SAL2050_R01_SUBTOTAL_TYPES.CUSTOMER,
	groupKey: '',
	groupLabel: '',
	count: 0,
	itemCd: '',
	itemNm: '',
	itemSpec: '',
};
